<template>
  <div class="extra-accesses-component">
    <div class="column is-8 is-offset-2">
      <div class="columns">
        <div class="column is-full">
          <p class="is-size-1 has-text-centered has-text-grey-dark dm-sans">
            Quantos acessos você vai criar no Pedbot?
          </p>
        </div>
      </div>
      <div class="choose-partners">
        <div class="columns mt-4">
          <div class="column is-full is-flex is-justify-content-center is-align-content-center">
            <div class="select is-large is-primary is-one-quarter">
              <select class="has-text-centered" v-model="extraAccesses.quantity">
                <option disabled selected>Selecionar</option>
                <option :value="number+1" v-for="(number) in accessesQuantity" :key="number">
                  {{ number+1 }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="columns mt-6">
          <div class="column is-full">
            <p class="is-size-4 has-text-centered has-text-grey-dark dm-sans">
              Cobramos um valor de R$ {{ formatPrice(extraAccesses.entity.price) }}/mês por acesso extra
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import extraAccessesApi from '@/apis/extraAccesses'
import { useAppStore } from "@/stores/AppStore";

export default {

  name: 'extra-accesses',

  data() {
    return {
      extraAccesses: {
        quantity: null,
        entity: {}
      }
    }
  },

  props: {
    formData: {
      required: true,
      type: Object
    }
  },

  watch: {
    'formData.plan': {
      handler() {
        this.getAccesses()
      },
      deep: true
    },
    'extraAccesses.quantity': function (quantity) {
      this.setExtraAccesses(quantity)
    }
  },

  computed: {
    accessesQuantity() {
      const array = [...Array(1000).keys()]
      let count = 0
      while (count < (this.formData.plan.data.max_accesses - 1)) {
        array.shift()
        count++
      }
      return array
    }
  },

  methods: {
    cleanData() {
      this.extraAccesses.quantity = null
    },
    formatPrice(value) {
      return (parseFloat(value).toLocaleString('pt-BR', { currency: 'BRL', style: 'currency' }))
          .replace('R$', '').trim();
    },
    setExtraAccesses(quantity) {
      if (quantity === null) {
        return;
      }
      this.formData.extraAccesses.data = []
      const extraAccess = JSON.parse(JSON.stringify(this.extraAccesses.entity))
      extraAccess.quantity = quantity
      // if (this.formData.messagePacket.data.mode === 2) {
      //   this.formData.messagePacket.data.quantity = quantity
      //   this.formData.messagePacket.data.price = ((parseFloat(this.formData.messagePacket.data.originalPrice) * quantity)).toString()
      // }
      const appStore = useAppStore()
      appStore.showReviewNextButton = true
      if (quantity === this.formData.plan.data.max_accesses) {
        extraAccess.price = 0
        this.formData.extraAccesses.showStep = false
        this.formData.extraAccesses.data = {}
        return;
      } else {
        this.formData.extraAccesses.showStep = true
        extraAccess.price = (parseFloat(this.extraAccesses.entity.price) * (quantity - this.formData.plan.data.max_accesses))
      }
      extraAccess.price = extraAccess.price.toString()

      this.formData.extraAccesses.data = extraAccess
    },
    async getAccesses() {
      if (this.formData.plan.data.id) {
        this.extraAccesses.entity = await extraAccessesApi.get({
          plan_id: this.formData.plan.data.id
        })
      }
    }
  }

}

</script>
